import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Day } from './day';
import { App } from '../interfaces';
import { style, media } from "typestyle";
import * as csstips from 'csstips';
import { DateTime } from 'luxon';

export interface DayProps {
  controller: App.Schedule.CalendarController;
  moment: DateTime;
}

export class Week extends React.Component<DayProps, undefined> {

  render() {

    const endDay = this.props.moment.endOf('week', { useLocaleWeeks: true });
    let currentDay = this.props.moment.startOf('week', { useLocaleWeeks: true });
    const days = [];

    while( currentDay < endDay) {

      days.push(<Day key={currentDay.ordinal} date={currentDay} controller={this.props.controller} />);

      currentDay = currentDay.plus({ days: 1 });

    }

    return (<div className={ 'week' }>{ days }</div>);

  }


}


// WEBPACK FOOTER //
// ./resources/src/components/schedule/week.tsx